import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [],
  exports: [
  ],
  imports: [
    SharedModule
  ]
})
export class CoreModule { }
